import { render, staticRenderFns } from "./updateCategory.vue?vue&type=template&id=f23c539e&"
import script from "./updateCategory.vue?vue&type=script&lang=js&"
export * from "./updateCategory.vue?vue&type=script&lang=js&"
import style0 from "./updateCategory.vue?vue&type=style&index=0&id=f23c539e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports